module.exports = __webpack_public_path__ + "img/16.51eac8d0.png";